export const LOGO_WIDTH = 140;
export const LOGO_HEIGHT = 69;
export const CONTENT_WIDTH_TABLET = 360;
